import React from 'react';
import fr from 'facet-rest';
import ChiliPiperConciergeComponent from './ChiliPiperConciergeComponent';
import LegacyChiliPiperConciergeComponent from './LegacyChiliPiperConciergeComponent';

const ChiliPiperConciergeComponentPicker = (props) => {
  const { resource } = props;
  return resource.withRelationship(
    fr.relationships.bookingScreenUpdates.name,
    () => <ChiliPiperConciergeComponent {...props} />,
    () => <LegacyChiliPiperConciergeComponent {...props} />,
  );
};

export default ChiliPiperConciergeComponentPicker;
